export const isValidForm = (data, captchaToken, setFormErrors, intl) => {
  const v = [];
  if (data.captcha && !captchaToken.current) {
    v.push({
      field: 'captcha',
      message: intl.formatMessage({
        id: 'formblock_requiredFieldMessage',
        defaultMessage: 'Fill-in this field',
      }),
    });
  }

  setFormErrors(v);
  return v.length === 0;
};
